import { render, staticRenderFns } from "./AdminSideMenu.vue?vue&type=template&id=23b17752&scoped=true"
import script from "./AdminSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSideMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminSideMenu.vue?vue&type=style&index=0&id=23b17752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b17752",
  null
  
)

export default component.exports